module.exports = __webpack_public_path__ + "static/15-862d2b324c1e8d11adcd8da6c889f10e.jpg";